export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8940.0debb4ce.jpg";